import { Flex, IconX, Button, csx } from '@vtex/admin-ui'
import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { getReduxStore } from '@/checkout-instore-legacy/redux/reduxStore'
import { changeCart } from '@/checkout-instore-legacy/cart/actions'
import { pipe } from 'ramda'

import { useHistory } from '../../../../../../core/router/useHistory'
import type { Customer, Profile } from '../../../../../../core/typings'

const isPresentString = pipe(
  (field: string | null | undefined) => field ?? '',
  (field) => field.trim(),
  (field) => field !== ''
)

const isClientComplete = (clientData: Profile | null) => {
  const { email, firstName, lastName } = clientData ?? {}

  // TODO<internationalization>: check if document and phone are required for other countries
  const isDocumentValid = true
  const isPhoneValid = true

  return (
    [email?.data, firstName?.data, lastName?.data].every(isPresentString) &&
    isDocumentValid &&
    isPhoneValid
  )
}

type InsightsNotificationBarProps = {
  customer: Customer
}

export const InsightsNotificationBar = ({
  customer,
}: InsightsNotificationBarProps) => {
  const history = useHistory()
  const { profile, openCart } = customer
  const [isVisible, setIsVisible] = useState(true)

  if (!isClientComplete(profile) && !openCart) {
    return null
  }

  const handleAlertClick = () => {
    if (openCart) {
      getReduxStore()?.dispatch(changeCart(openCart.orderFormId))
    } else {
      history.push('/client-profile')
    }
  }

  const handleCloseClick = () => {
    setIsVisible(false)
  }

  if (!isVisible) {
    return null
  }

  return (
    <Flex
      justify="space-between"
      className={csx({
        marginTop: '$space-4',
        background: '$lightBlue10',
        borderRadius: 4,
        border: '1px solid $lightBlue30',
        padding: '$space-3',
        '@desktop': {
          paddingX: '$space-7',
          alignItems: 'center',
        },
      })}
    >
      <div
        className={csx({
          '@desktop': {
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
          },
        })}
      >
        <p>
          <FormattedMessage
            id={
              openCart
                ? 'checkout.openCartFound'
                : 'checkout.generic.notification'
            }
          />
        </p>
        <Button
          variant="neutralTertiary"
          className={csx({
            color: '$gray50',
          })}
          onClick={handleAlertClick}
        >
          <FormattedMessage
            id={openCart ? 'checkout.seeCart' : 'checkout.viewProfile'}
          />
        </Button>
      </div>
      <Button
        variant="neutralTertiary"
        onClick={handleCloseClick}
        icon={
          <IconX
            className={csx({
              height: '11px',
              color: '$gray50',
            })}
          />
        }
      />
    </Flex>
  )
}
